import { Component, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-alert-sucesso-aprovacao',
    templateUrl: './alert-sucesso-aprovacao.component.html',
    styleUrls: ['./alert-sucesso-aprovacao.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager
})
export class AlertSucessoAprovacaoComponent {

  @Output() alertSucessoAprovacao = new EventEmitter();

  constructor() { }

  fecharAlertSucessoAprovacao() {
    this.alertSucessoAprovacao.emit('fechou');
  }

}
